<button  *ngIf="item && item.cells" mat-button class="link-button" (click)="onClicked('Edit')">
  {{item.cells[fieldDefinition.key] ? item.cells[fieldDefinition.key].displayText : ''}}
</button>
